import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { auth } from "@/lib/api";

export default function BAA() {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (auth.user()?.baa_acknowledged) navigate("/dashboard");
  }, [navigate]);

  const accept = async () => {
    setLoading(true);
    try {
      await auth.ackBAA();
      toast.success("BAA acknowledged. HIPAA audit logging enabled.");
      navigate("/dashboard");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center p-6" data-testid="baa-page">
      <div className="max-w-2xl w-full bg-white border border-brand rounded-2xl p-10 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-xl bg-brand-primary flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-white" />
          </div>
          <div>
            <div className="eyebrow">First Login Compliance</div>
            <h1 className="text-2xl font-semibold tracking-tight text-brand-text">Business Associate Agreement</h1>
          </div>
        </div>
        <div className="prose prose-sm max-w-none text-brand-text/90 leading-relaxed text-sm space-y-3">
          <p>By using ZidaMD ("Platform"), you acknowledge that the Platform handles Protected Health Information ("PHI") and operates as a Business Associate under the Health Insurance Portability and Accountability Act ("HIPAA") of 1996.</p>
          <p><strong>You agree to:</strong> (a) only access PHI necessary for your role; (b) report any suspected breach within 24 hours; (c) use AI-generated documents as drafts that require physician review before signing; and (d) consent to immutable audit logging of every action taken in the Platform.</p>
          <p><strong>The Platform agrees to:</strong> (a) implement administrative, physical, and technical safeguards consistent with the HIPAA Security Rule; (b) ensure all subcontractors providing AI inference are bound by equivalent BAAs; (c) maintain audit logs for a minimum of 6 years.</p>
          <p className="text-brand-muted text-xs">This is a representative acknowledgment for the demonstration environment. Production agreements are countersigned by CamelionAI Privacy Office.</p>
        </div>
        <label className="flex items-center gap-2.5 mt-6 text-sm">
          <input type="checkbox" checked={agreed} onChange={(e)=>setAgreed(e.target.checked)}
            className="w-4 h-4 accent-[#4A0E8F]" data-testid="baa-checkbox" />
          I acknowledge the BAA and consent to HIPAA audit logging.
        </label>
        <button onClick={accept} disabled={!agreed || loading}
          className="mt-6 bg-brand-primary text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-[#35096B] transition-colors disabled:opacity-50"
          data-testid="baa-accept">
          {loading ? "Acknowledging…" : "Continue to ZidaMD"}
        </button>
      </div>
    </div>
  );
}
